import { useAPI } from "hooks/api";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export function useVision() {
  const { get } = useAPI();
  const { pathname } = useLocation();
  const [status, setStatus] = useState("idle");
  const [data, setData] = useState(undefined);

  useEffect(() => {
    setStatus("fetching");
    get("/coach-connect/vision")
      .then((res) => {
        setData(Array.isArray(res?.result) ? res.result : []);
        setStatus("fetched");
      })
      .catch(() => {
        setStatus("error");
      });
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return { status, data };
}
